
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ArrowUpRight, ChevronDown, ExternalLinkIcon } from "lucide-react";

const RecommendationCard = ({
  title,
  iconUrl,
  links,
  content,
}: {
  title: string;
  iconUrl: string;
  links: {
    label: string;
    href: string;
  }[];
  content: React.ReactNode;
}) => {
  return (
    <Collapsible defaultOpen>
      <Card className="overflow-hidden">
        <CollapsibleTrigger className="w-full group">
          <CardHeader className="p-4 hover:bg-muted/50 transition-colors">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-12 h-12 rounded-md bg-muted flex items-center justify-center shrink-0">
                  <img
                    src={iconUrl}
                    alt="Recommendation Icon"
                    width={32}
                    height={32}
                  />
                </div>
                <CardTitle className="text-base font-medium flex items-center gap-2 text-foreground text-left">
                  {title}
                </CardTitle>
              </div>

              <ChevronDown className="w-4 h-4 text-muted-foreground transition-transform duration-200 group-data-[state=open]:-rotate-90 shrink-0" />
            </div>
          </CardHeader>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <CardContent className="p-4 border-t text-muted-foreground">
            <div className="recommendation-card-content">{content}</div>
            <div className="flex flex-wrap gap-2 mt-4">
              {links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button variant="secondary" size="sm" className="w-fit">
                    {link.label}
                    <ArrowUpRight />
                  </Button>
                </a>
              ))}
            </div>
          </CardContent>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  );
};

export default RecommendationCard;
